import Swal from "sweetalert2";

export const my_shop_data_methods = {
    get_active_base_products() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_active_base_products/`,
                type: "GET",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json",
                },
                success: (response) => {
                    if (response.status === "success") {
                        this.sync_catalogue_items(response.data || []);
                        const first_product = (response.data || []).find(Boolean);
                        if (first_product?.base_profile) {
                            this.shop_profile = first_product.base_profile;
                            this.base_profile_id = first_product.base_profile.id || this.base_profile_id;
                        }
                        resolve(response.data || []);
                        return;
                    }

                    reject(new Error(response.message || "Failed to load active products."));
                },
                error: (xhr) => {
                    reject(new Error(xhr.responseJSON?.message || "Failed to load active products."));
                }
            });
        });
    },
    get_active_base_services() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_active_base_services/`,
                type: "GET",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json",
                },
                success: (response) => {
                    if (response.status === "success") {
                        const services = response.data || [];
                        const existing_products = this.catalogue_products || [];
                        this.sync_catalogue_items([...existing_products, ...services]);
                        const first_service = services.find(Boolean);
                        if (!this.base_profile_id && first_service?.base_profile) {
                            this.shop_profile = first_service.base_profile;
                            this.base_profile_id = first_service.base_profile.id || this.base_profile_id;
                        }
                        resolve(services);
                        return;
                    }

                    reject(new Error(response.message || "Failed to load active services."));
                },
                error: (xhr) => {
                    const message = typeof xhr?.responseJSON?.message === "string"
                        ? xhr.responseJSON.message
                        : xhr?.responseJSON?.message
                            ? JSON.stringify(xhr.responseJSON.message)
                            : "Failed to load active services.";
                    reject(new Error(message));
                }
            });
        });
    },
    get_requests() {
        return new Promise((resolve) => {
            if (!this.base_profile_id) {
                this.requests = [];
                resolve([]);
                return;
            }

            $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_service_requests/`,
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                },
                data: JSON.stringify({
                    profile_id: this.base_profile_id
                }),
                contentType: "application/json",
                success: (response) => {
                    if (response.status === "success") {
                        this.requests = (response.data || []).map((request) => ({
                            ...request,
                            is_loading: false,
                            show_decline: false,
                        }));
                        resolve(this.requests);
                        return;
                    }

                    this.requests = [];
                    this.errors.requests = response.message || "Failed to load requests.";
                    resolve([]);
                },
                error: (xhr) => {
                    const message = typeof xhr?.responseJSON?.message === "string"
                        ? xhr.responseJSON.message
                        : xhr?.responseJSON?.message
                            ? JSON.stringify(xhr.responseJSON.message)
                            : "Failed to load requests.";
                    this.requests = [];
                    this.errors.requests = message;
                    resolve([]);
                }
            });
        });
    },
    get_orders() {
        return new Promise((resolve) => {
            if (!this.base_profile_id) {
                this.orders = [];
                resolve([]);
                return;
            }

            $.ajax({
                type: "POST",
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_orders/`,
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                },
                data: JSON.stringify({
                    base_profile_id: this.base_profile_id
                }),
                contentType: "application/json",
                success: (response) => {
                    if (response.status === "success") {
                        this.orders = response.data || [];
                        resolve(response.data);
                        return;
                    }

                    this.orders = [];
                    this.errors.orders = response.message || "Failed to load orders.";
                    resolve([]);
                },
                error: (xhr) => {
                    const message = typeof xhr?.responseJSON?.message === "string"
                        ? xhr.responseJSON.message
                        : xhr?.responseJSON?.message
                            ? JSON.stringify(xhr.responseJSON.message)
                            : "Failed to load orders.";
                    this.orders = [];
                    this.errors.orders = message;
                    resolve([]);
                }
            });
        });
    },
    fetch_categories() {
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_categories/`,
            type: "GET",
            headers: {
                Authorization: `Token ${this.getToken()}`,
                "Content-Type": "application/json",
            },
            success: (response) => {
                if (response.status === "success") {
                    this.categories = response.categories || [];
                    if (this.modal_product?.category) {
                        const category = this.categories.find((cat) => cat.name === this.modal_product.category);
                        if (category) {
                            this.selected_category = category.id;
                            this.fetch_subcategories(category.id);
                        }
                    }
                }
            }
        });
    },
    fetch_subcategories(category_id) {
        this.selected_subcategory = null;
        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_subcategories/`,
            type: "POST",
            headers: {
                Authorization: `Token ${this.getToken()}`,
                "Content-Type": "application/json",
            },
            data: JSON.stringify({ category_id }),
            success: (response) => {
                if (response.status === "success") {
                    this.subcategories = response.subcategories || [];
                    if (this.modal_product?.subcategory) {
                        const subcategory = this.subcategories.find((sub) => sub.name === this.modal_product.subcategory);
                        if (subcategory) {
                            this.update_item_form.subcategory_id = subcategory.id;
                        }
                    }
                }
            }
        });
    },
    update_request(request, type, reason = "") {
        const base_url = `${window.location.origin}/my_orders`;
        request.is_loading = true;

        $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_service_request_status/`,
            headers: {
                Authorization: `Token ${this.getToken()}`,
            },
            data: JSON.stringify({
                request_id: request.id,
                action: type,
                return_message: reason || "",
                base_url: base_url,
            }),
            contentType: "application/json",
            success: (response) => {
                if (response.status === "success") {
                    Swal.fire({
                        title: "Success",
                        text: "Request updated successfully!",
                        icon: "success",
                        timer: 1200,
                        showConfirmButton: false,
                        position: "bottom-end",
                        toast: true,
                    });
                    this.get_requests();
                }
            },
            error: (xhr) => {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: xhr.responseJSON?.message || "Failed to update request.",
                    position: "bottom-end",
                    toast: true,
                    showConfirmButton: false,
                    timer: 2500,
                });
            },
            complete: () => {
                request.is_loading = false;
            }
        });
    },
};
